import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
var AuthInterceptor = /** @class */ (function () {
    function AuthInterceptor() {
    }
    AuthInterceptor.prototype.intercept = function (req, next) {
        var infoLogin = JSON.parse(sessionStorage.getItem("login"));
        if (infoLogin && infoLogin.token) {
            var token = infoLogin.token;
            req = req.clone({
                setHeaders: {
                    'X-Authorization-Token': token
                }
            });
        }
        return next.handle(req);
    };
    AuthInterceptor = tslib_1.__decorate([
        Injectable(),
        tslib_1.__metadata("design:paramtypes", [])
    ], AuthInterceptor);
    return AuthInterceptor;
}());
export { AuthInterceptor };
//# sourceMappingURL=auth.interceptor.js.map